import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { Survey } from "../../types/Survey";

export const getSurvey = (surveyId: string, options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["surveys", surveyId],
    queryFn: (): Promise<Survey> => {
      return fetchWithAuth<Survey>("getSurvey", surveyId);
    },
    enabled: isQueryEnabled(options),
  });
};
